import { PageHero } from "../components/PageHero";
import { Innovation } from "../components/home/Innovation";
import { Reveal } from "../components/Reveal";

const FEATURES = [
  {
    label: "Thermal Resilience",
    body: "nTHERM sustains extreme thermal loads without structural degradation, protecting occupants and maintaining component integrity where legacy materials fail.",
  },
  {
    label: "Mass Reduction",
    body: "A dramatically lighter composite lattice reduces platform weight — improving mobility, fuel efficiency, and payload capacity across applications.",
  },
  {
    label: "Impact Absorption",
    body: "Engineered energy-dissipation geometry multiplies durability, extending service life and survivability under repeated stress.",
  },
];

export default function InnovationPage() {
  return (
    <div data-testid="innovation-page">
      <PageHero
        overline="Innovation · Technology"
        title={["nTHERM", "materials", "science."]}
        subtitle="The proprietary composite platform at the core of every Ascendance product — lighter, tougher, and more thermally resilient than anything that came before."
      />

      {/* nTHERM deep dive */}
      <section className="bg-ink py-20 md:py-28">
        <div className="container-x">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-px border-t border-l border-white/10">
            {FEATURES.map((f, i) => (
              <Reveal key={f.label} delay={i * 0.1}>
                <div className="group border-r border-b border-white/10 p-8 md:p-12 h-full hover:bg-panel transition-colors duration-500">
                  <span className="font-heading text-5xl font-bold text-white/10 group-hover:text-steel/60 transition-colors duration-500">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="font-heading text-2xl font-semibold uppercase tracking-tight text-textmain mt-6 mb-4">
                    {f.label}
                  </h3>
                  <p className="text-textmuted leading-relaxed">{f.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Innovation />
    </div>
  );
}
